import StandalonePrintProductConfigurator from './StandalonePrintProductConfigurator';

export default StandalonePrintProductConfigurator;
